import axios from 'axios'
import qs from 'qs'
import { paramsSerializerQs } from '@/helpers/api'
import store from '@/store'
import { getTokenData } from '@/services/token.service'
import i18nService from '../services/i18n.service'
import router from "@/router";

let isRefreshing = false
let subscribers = []
const subscribeTokenRefresh = (onSuccess, onFailure) => subscribers.push({ onSuccess, onFailure })
const onRefreshed = token => {
  subscribers.forEach(({ onSuccess }) => onSuccess(token))
  subscribers = []
}
const onRefreshFailed = err => {
  subscribers.forEach(({ onFailure }) => onFailure(err))
  subscribers = []
}

// шлём POST с X-HTTP-Method-Override: GET, параметры query уходят JSON-телом.
// Без заголовка POST на list-URL — это создание сущности, поэтому заголовок обязателен.
const MAX_GET_QUERY_LENGTH = 2000
const overrideLongGetToPost = config => {
  if (config.method !== 'get' || !config.params) return
  const { paramsSerializer } = config
  const serialize =
    (typeof paramsSerializer === 'function' ? paramsSerializer : paramsSerializer?.serialize) || paramsSerializerQs
  const query = serialize(config.params)
  if (query.length <= MAX_GET_QUERY_LENGTH) return
  config.method = 'post'
  // Обратный разбор строки query даёт тело, идентичное тому, что бэк получил бы из URL
  config.data = qs.parse(query, { depth: 20, arrayLimit: Infinity, parameterLimit: Infinity })
  config.headers = { ...config.headers, 'Content-Type': 'application/json', 'X-HTTP-Method-Override': 'GET' }
  delete config.params
}

const axiosApiInstance = axios.create({
  baseURL: `${process.env.VUE_APP_BACKEND_ORIGIN}/api`,
})

axiosApiInstance.interceptors.request.use(
  config => {
    config.headers = {
      Accept: 'application/json',
      'Accept-Language': config.loc || i18nService.getActiveLanguage(),
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      ...(config?.params?.isFilter ? {} : {'additional-groups': 'detailed'}),
      ...config.headers,
    }
    delete config?.params?.isFilter
    overrideLongGetToPost(config)
    const tokenData = getTokenData()
    if (tokenData && config.url !== 'token/refresh') {
      const { token } = JSON.parse(tokenData)
      config.headers.Authorization = 'Bearer ' + token
    }
    const globalFilter = window.localStorage.getItem('admin_global_filter')
    if (globalFilter !== null && +globalFilter !== 0){
      config.headers['group-filter'] = +globalFilter
    }
    return config
  },
  error => {
    return Promise.reject(error)
  },
)

axiosApiInstance.interceptors.response.use(
  response => {
    return response
  },
  async function (err) {
    const config = err.config
    const status = err.response ? err.response.status : null
    const originalRequest = config
    if (status === 401 && !['token/refresh', 'token/logout'].includes(config.url)) {
      if (!isRefreshing) {
        isRefreshing = true
        store
          .dispatch('AuthModule/onRefreshToken')
          .then(data => {
            isRefreshing = false
            onRefreshed(data.token)
            subscribers = []
          })
          .catch(err => {
            isRefreshing = false
            onRefreshFailed(err)
            store.dispatch('AuthModule/onLogout').catch(() => {})
          })
      }
      return new Promise((resolve, reject) => {
        subscribeTokenRefresh(
          token => {
            originalRequest.headers.Authorization = `Bearer ${token}`
            resolve(axiosApiInstance(originalRequest))
          },
          err => reject(err),
        )
      })
    }
    if (status === 401 && ['token/refresh', 'token/logout'].includes(config.url)){
      store.commit('AuthModule/purgeAuth')
    }
    if(status === 403 && !config.skip403Redirect){
      router.push({ name: 'PageError403' })
    }
    return Promise.reject(err)
  },
)

export default axiosApiInstance
